import React from 'react'

import AboutSection from '../Home/HomeInner/AboutSection'
import MedtrustFooter from '../../Compoents/MedtrustFooter'
import BreadcrumbArea from '../../ShearOne/BreadcrumbArea'
import MedtrustHeader from '../../Compoents/MedtrustHeader'
import TestimonialSlider from '../Home/HomeInner/FAQSlider'
import ConsultationsForm from '../Contact/ContactInnerSection/ConsultationForm'
// import Appoinment from '../Home/HomeInner/Appoinment'


export const MedtrustAbout = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'About Us', active: true }
    ];
    return (
        <>

            <MedtrustHeader />
            <BreadcrumbArea
                title="About Us"
                backgroundImage="/assets/imgs/breadcrumb/page-header-1.png"
                links={breadcrumbLinks}
            />

            <AboutSection />


            <SolutionProvide />
            <SolutionProvideMedtrust />
            <OurTeam />
            {/* <ProductService /> */}
            <SupportLayout />
            

            <ConsultationsForm />
            <FocusPoint />
            <MedtrustFooter />
        </>
    )
}


export const OurTeam = () => {
    return (
        <>
            <section class="wellness-expertise section-space__bottom">
                <div class="container">
                    <div class="row align-items-center">
                        <h5 class="section__subtitle color-theme-primary mb-15 mb-xs-10 title-animation"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid" /> Our Expertise </h5>
                        <h3 class="section__title mb-15 mb-xs-10  title-animation">SQUARE MEDTRUST’s cross-functional team are a mixture of trained healthcare professionals with Cardiovascular Medicine (Cath-Lab specialty), Ultra-sonography, Dentistry, Orthopedic Surgery, General Practitioners, Nurse and Multidisciplinary clinical specialist’s professional backgrounds for patiet’s special care & doctor’s training.</h3>
                        <div class="col-lg-6">
                            <div class="wellness-expertise__content">


                                <h3 className='mb-15 mb-xs-10 font-semibold'>Our team of experienced professionals brings together a wealth of knowledge and expertise in:</h3>
                                <ul class="wellness-expertise__content__list">
                                    <li><i class="fa-solid fa-check"></i> Clinical research </li>
                                    <li><i class="fa-solid fa-check"></i>Consultations </li>
                                    <li><i class="fa-solid fa-check"></i>Pre-treatment evaluations</li>
                                    <li><i class="fa-solid fa-check"></i>Second opinions</li>
                                    <li><i class="fa-solid fa-check"></i>Bi-lingual advocacy</li>
                                    <li><i class="fa-solid fa-check"></i>Multi-disciplinary care coordination (MDT) </li>
                                    <li><i class="fa-solid fa-check"></i> Telemedicine & Video consultations </li>
                                    <li><i class="fa-solid fa-check"></i>Emergency Response & Crisis management </li>
                                    <li><i class="fa-solid fa-check"></i>Medical Travel Documentations</li>
                                    <li><i class="fa-solid fa-check"></i>Visa and travel assistance Service</li>
                                    <li><i class="fa-solid fa-check"></i>Complete patients & doctors care</li>
                                    <li><i class="fa-solid fa-check"></i>Medical tourism </li>
                                </ul>
                                <br />

                            </div>
                        </div>

                        <div class="col-lg-6">
                            <div class="wellness-expertise__media">
                                <img src="./assets/imgs/wellness-expertise/wellness-expertise.png" class="img-fluid" alt="image not found" />

                                <div class="wellness-expertise__media__box">
                                    <div class="wellness-expertise__media__box-icon">
                                        <img class="img-fluid" src="assets/imgs/wellness-expertise/note.svg" alt="icon not found" />
                                    </div>
                                    <div class="wellness-expertise__media__box-text">
                                        <h3><span class="odometer" data-count="380">0</span>+</h3>
                                        <h6>Success Case</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}


export const SolutionProvide = () => {
    return (
        <>

            {/* <h5 class="section__subtitle color-theme-primary  mb-1 mb-xs-1 title-animation"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid"/> Services provide by SQUARE MEDTECH</h5> */}
            {/* <h3 class="section__title mb-15 mb-xs-10  title-animation">We aim R&amp;D, consultation and Training Services to:</h3> */}
            {/* <div class="row mb-minus-50 mt-50">
                
                <div class="col-xl-3 col-lg-3 col-sm-6">
                    
                    <div class="service-3__item mb-50">
                        <div class="service-3__item-header d-flex mb-20 mb-xs-15">
                            <div class="service-3__item-header-icon">
                                <img class="img-fluid" src="assets/imgs/service-3/service-icon-2.png" alt="icon not found"/>
                            </div>
                            <h2 class="mb-0">01</h2>
                        </div>

                        <h4 class="mb-0 font-semibold">Medical Device Industry</h4>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-sm-6">
                    <div class="service-3__item mb-50">
                        <div class="service-3__item-header d-flex mb-20 mb-xs-15">
                            <div class="service-3__item-header-icon">
                                <img class="img-fluid" src="assets/imgs/service-3/service-icon-3.png" alt="icon not found"/>
                            </div>
                            <h2 class="mb-0">02</h2>
                        </div>

                        <h4 class="mb-0 font-semibold">Pharmaceutical &amp; Biotech Industry</h4>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-sm-6">
                    <div class="service-3__item mb-50">
                        <div class="service-3__item-header d-flex mb-20 mb-xs-15">
                            <div class="service-3__item-header-icon">
                                <img class="img-fluid" src="assets/imgs/service-3/service-icon-4.png" alt="icon not found"/>
                            </div>
                            <h2 class="mb-0">03</h2>
                        </div>

                        <h4 class="mb-0 font-semibold">Academic Institutions</h4>
                    </div>
                </div>

                 <div class="col-xl-3 col-lg-3 col-sm-6">
                    <div class="service-3__item mb-50">
                        <div class="service-3__item-header d-flex mb-20 mb-xs-15">
                            <div class="service-3__item-header-icon">
                                <img class="img-fluid" src="assets/imgs/service-3/service-icon-4.png" alt="icon not found"/>
                            </div>
                            <h2 class="mb-0">04</h2>
                        </div>

                        <h4 class="mb-0 font-semibold">Health Care Providers (Hospitals &amp; Doctors)</h4>
                    </div>
                </div>
            </div> */}

            <section class="our-projects section-space__bottom">
                <div class="container">
                    <div class="row mb-minus-30">
                        <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                            <div class="our-projects__item has--title">
                                <div class="section__title-wrapper our-projects__content">
                                    <h5 class="section__subtitle color-theme-primary"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid" />Services provide by SQUARE MEDTECH</h5>
                                    <h4 class="section__title mb-0 title-animation">We aim R&amp;D, consultation and Training Services to:</h4>
                                </div>
                                {/* <a href="about-us.html" class="rr-btn">
                        <span class="btn-wrap">
                            <span class="text-one">View All <i class="fa-solid fa-plus"></i></span>
                            <span class="text-two">View All <i class="fa-solid fa-plus"></i></span>
                        </span>
                        </a> */}
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                            <div class="our-projects__item position-relative overflow-hidden">
                                <div class="panel wow"></div>
                                <div class="our-projects__item__content">
                                    <div class="our-projects__item__content-media">
                                        <img src="assets/imgs/ask-quesiton/Medical_Device Industry_2.png" class="img-fluid" alt="" />
                                    </div>
                                    <div class="our-projects__item__content-icon">

                                    </div>
                                    <div class="our-projects__item__content-text">
                                        <h4 class="title-animation">Medical Device Industry</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                            <div class="our-projects__item position-relative overflow-hidden">
                                <div class="panel wow"></div>
                                <div class="our-projects__item__content">
                                    <div class="our-projects__item__content-media">
                                        <img src="assets/imgs/ask-quesiton/Pharmaceutical & Biotech.png" class="img-fluid" alt="" />
                                    </div>
                                    <div class="our-projects__item__content-icon">
                                    </div>
                                    <div class="our-projects__item__content-text">
                                        <h4 class="title-animation">Pharmaceutical &amp; Biotech Industry</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                            <div class="our-projects__item position-relative overflow-hidden">
                                <div class="panel wow"></div>
                                <div class="our-projects__item__content">
                                    <div class="our-projects__item__content-media">
                                        <img src="assets/imgs/ask-quesiton/Academic Institutions.png" class="img-fluid" alt="" />
                                    </div>
                                    <div class="our-projects__item__content-icon">
                                    </div>
                                    <div class="our-projects__item__content-text">
                                        <h4 class="title-animation">Academic Institutions</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                            <div class="our-projects__item position-relative overflow-hidden">
                                <div class="panel wow"></div>
                                <div class="our-projects__item__content">
                                    <div class="our-projects__item__content-media">
                                        <img src="assets/imgs/ask-quesiton/Health Care Providers.png" class="img-fluid" alt="" />
                                    </div>
                                    <div class="our-projects__item__content-icon">
                                    </div>
                                    <div class="our-projects__item__content-text">
                                        <h4 class="title-animation">Health Care Providers (Hospitals &amp; Doctors)</h4>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>

        </>
    )
}


export const SolutionProvideMedtrust = () => {
    return (
        <>

            {/* <h5 class="section__subtitle color-theme-primary  mb-1 mb-xs-1 title-animation"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid"/> Services provide by SQUARE MEDTRUST</h5> */}
            {/* <h3 class="section__title mb-15 mb-xs-10  title-animation">SQUARE MEDTRUST is a patients &amp; doctors centric dedicated subsidiary of SQUARE MEDTECH for:</h3> */}
            {/* <div class="row mb-minus-50 mt-50">
                
                <div class="col-xl-3 col-lg-3 col-sm-6">
                    
                    <div class="service-3__item mb-50">
                        <div class="service-3__item-header d-flex mb-20 mb-xs-15">
                            <div class="service-3__item-header-icon">
                                <img class="img-fluid" src="assets/imgs/service-3/service-icon-2.png" alt="icon not found"/>
                            </div>
                            <h2 class="mb-0">01</h2>
                        </div>

                        <h4 class="mb-0 font-semibold">International Medical Care (IMC)</h4>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-sm-6">
                    <div class="service-3__item mb-50">
                        <div class="service-3__item-header d-flex mb-20 mb-xs-15">
                            <div class="service-3__item-header-icon">
                                <img class="img-fluid" src="assets/imgs/service-3/service-icon-3.png" alt="icon not found"/>
                            </div>
                            <h2 class="mb-0">02</h2>
                        </div>

                        <h4 class="mb-0 font-semibold">International Physician Consultation for foreign patients</h4>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-sm-6">
                    <div class="service-3__item mb-50">
                        <div class="service-3__item-header d-flex mb-20 mb-xs-15">
                            <div class="service-3__item-header-icon">
                                <img class="img-fluid" src="assets/imgs/service-3/service-icon-4.png" alt="icon not found"/>
                            </div>
                            <h2 class="mb-0">03</h2>
                        </div>

                        <h4 class="mb-0 font-semibold">International Doctors Training Program</h4>
                    </div>
                </div>

                 <div class="col-xl-3 col-lg-3 col-sm-6">
                    <div class="service-3__item mb-50">
                        <div class="service-3__item-header d-flex mb-20 mb-xs-15">
                            <div class="service-3__item-header-icon">
                                <img class="img-fluid" src="assets/imgs/service-3/service-icon-4.png" alt="icon not found"/>
                            </div>
                            <h2 class="mb-0">04</h2>
                        </div>

                        <h4 class="mb-0 font-semibold">International Medical Tourism</h4>
                    </div>
                </div>
            </div> */}
            <section class="our-projects section-space__bottom">
                <div class="container">
                    <div class="row mb-minus-30">
                        <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                            <div class="our-projects__item has--title">
                                <div class="section__title-wrapper our-projects__content">
                                    <h5 class="section__subtitle color-theme-primary"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid" />Services provide by SQUARE MEDTRUST</h5>
                                    <h4 class="section__title mb-0 title-animation">SQUARE MEDTRUST is a patients &amp; doctors centric dedicated subsidiary of SQUARE MEDTECH for:</h4>
                                </div>
                                {/* <a href="about-us.html" class="rr-btn">
                        <span class="btn-wrap">
                            <span class="text-one">View All <i class="fa-solid fa-plus"></i></span>
                            <span class="text-two">View All <i class="fa-solid fa-plus"></i></span>
                        </span>
                        </a> */}
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                            <div class="our-projects__item position-relative overflow-hidden">
                                <div class="panel wow"></div>
                                <div class="our-projects__item__content">
                                    <div class="our-projects__item__content-media">
                                        <img src="assets/imgs/ask-quesiton/International Medical Care.png" class="img-fluid" alt="" />
                                    </div>
                                    <div class="our-projects__item__content-icon">

                                    </div>
                                    <div class="our-projects__item__content-text">
                                        <h4 class="title-animation">International Medical Care (IMC)</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                            <div class="our-projects__item position-relative overflow-hidden">
                                <div class="panel wow"></div>
                                <div class="our-projects__item__content">
                                    <div class="our-projects__item__content-media">
                                        <img src="assets/imgs/ask-quesiton/International Physician Consultation.png" class="img-fluid" alt="" />
                                    </div>
                                    <div class="our-projects__item__content-icon">
                                    </div>
                                    <div class="our-projects__item__content-text">
                                        <h4 class="title-animation">International Physician Consultation for foreign patients</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                            <div class="our-projects__item position-relative overflow-hidden">
                                <div class="panel wow"></div>
                                <div class="our-projects__item__content">
                                    <div class="our-projects__item__content-media">
                                        <img src="assets/imgs/ask-quesiton/International Doctors Training.jpg" class="img-fluid" alt="" />
                                    </div>
                                    <div class="our-projects__item__content-icon">
                                    </div>
                                    <div class="our-projects__item__content-text">
                                        <h4 class="title-animation">International Doctors Training Program</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                            <div class="our-projects__item position-relative overflow-hidden">
                                <div class="panel wow"></div>
                                <div class="our-projects__item__content">
                                    <div class="our-projects__item__content-media">
                                        <img src="assets/imgs/ask-quesiton/International Medical Tourism.png" class="img-fluid" alt="" />
                                    </div>
                                    <div class="our-projects__item__content-icon">
                                    </div>
                                    <div class="our-projects__item__content-text">
                                        <h4 class="title-animation">International Medical Tourism</h4>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>

        </>
    )
}

export const ProductService = () => {
    return (
        <>
            <section class="service-4 ">
                <div class="container">
                    <div class="col-lg-12">
                        <div class="">
                            <h5 class="section__subtitle color-theme-primary mb-15 mb-xs-10 title-animation"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid" /> How we support   </h5>

                        </div>
                    </div>
                    <div class="row mb-minus-30" >
                        <div class="col-xl-3 col-lg-3 col-md-6">
                            <div class="service-4__item mb-30">
                                <div class="service-4__item-icon mb-20 mb-xs-15">
                                    <img src="assets/imgs/service-4/services__item-1.png" alt="icon not found" />
                                </div>
                                <div class="service-4__item-text">
                                    <p>We provide need-based service (NBS). We do cooperation with your &amp; institutions according to your requirements. </p>

                                    <a class="rr-a-btn mb-8" >Read More <i class="fa-solid fa-circle-plus"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-6">
                            <div class="service-4__item mb-30">
                                <div class="service-4__item-icon mb-20 mb-xs-15">
                                    <img src="assets/imgs/service-4/services__item-1.png" alt="icon not found" />
                                </div>
                                <div class="service-4__item-text">
                                    <p>We do Evaluation based Pre-Consultations. </p>

                                    <a class="rr-a-btn mb-8" >Read More <i class="fa-solid fa-circle-plus"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-6">
                            <div class="service-4__item mb-30">
                                <div class="service-4__item-icon mb-20 mb-xs-15">
                                    <img src="assets/imgs/service-4/services__item-1.png" alt="icon not found" />
                                </div>
                                <div class="service-4__item-text">
                                    <p>We provide Second Opinion Consultations according to your needs. </p>

                                    <a class="rr-a-btn mb-8" >Read More <i class="fa-solid fa-circle-plus"></i></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-6">
                            <div class="service-4__item mb-30">
                                <div class="service-4__item-icon mb-20 mb-xs-15">
                                    <img src="assets/imgs/service-4/services__item-1.png" alt="icon not found" />
                                </div>
                                <div class="service-4__item-text">
                                    <p>We assist you in eliminating the language barriers. </p>

                                    <a class="rr-a-btn mb-8" >Read More <i class="fa-solid fa-circle-plus"></i></a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
        </>
    )
}

export const ClientsTestinomial = () => {
    return (
        <>
            <section class="client-testimonial section-space overflow-hidden">
                <div class="container">
                    <div class="client-testimonial__shape"><img class="img-fluid" src="assets/imgs/testimonial/client-testimonial__helth.png" alt="icon not found" /></div>
                    <div class="row align-items-end mb-60 mb-sm-50 mb-xs-40">
                        <div class="col-lg-7">
                            <div class="section__title-wrapper client-testimonial__content">
                                <h5 class="section__subtitle color-theme-primary mb-15 mb-xs-10 title-animation"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid" /> Clients Testimonial</h5>
                                <h2 class="section__title mb-0 title-animation">Nurture Nature Blossoming in Health and Happiness</h2>
                            </div>
                        </div>

                        <div class="col-lg-5">
                            <div class="client-testimonial__content-right mt-md-25 mt-sm-25 mt-xs-25">
                                <p class="mb-0">Medical science encompasses a vastf fields dedicated to understanding and treating ailments, promotin health, and enhanci quality of life. Here's a brief exploration into this multifaceted domain medical student</p>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <div class="client-testimonial__media">
                                <img class="img-fluid" src="assets/imgs/client-testimonial/client-testimonial.png" alt="icon not found" />
                            </div>
                        </div>

                        <div class="col-lg-6">
                            <TestimonialSlider />

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}




export const FocusPoint = () => {
    return (
        <>
            <section class="footer__cta footer__cta-bottom-up mb-10">
                <div class="container">
                    <div class="row mb-minus-30">
                        <div class="col-md-6">
                            <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                                <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                                    <img class="img-fluid" src="assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found" />
                                </div>

                                <div class="footer__cta-item-text">
                                    <h4 class="color-white mb-15 mb-10">We Believe:</h4>
                                    <ul class="color-white mb-0">
                                        <li>Be at the forefront of medical innovation</li>
                                        <li>Fostering scientific advancements</li>
                                        <li>Global health and well-being</li>
                                    </ul>

                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                                <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                                    <img class="img-fluid" src="assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found" />
                                </div>

                                <div class="footer__cta-item-text">
                                    <h4 class="color-white mb-15 mb-10">We Focus:</h4>
                                    <ul class="color-white mb-0">
                                        <li>Excellence in Research</li>
                                        <li>Collaborative Partnerships</li>
                                        <li>Innovative Solutions</li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}


const SupportLayout = () => {

    return (
       
            <section class="service-4 section-space">
                <div class="container">
                    <div class="col-lg-12">
                    <div class="">
                        <h5 class="section__subtitle color-theme-primary mb-15 mb-xs-10 title-animation"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid" /> How we support   </h5>

                    </div>
                </div>
                    <div class="row mb-minus-30">
                        <div class="col-xl-3 col-lg-3 col-md-6">
                            <div class="service-4__item mb-30">
                                <div class="service-4__item-icon mb-40 mb-xs-20">
                                    <img src="assets/imgs/about-us/NEED-BASED SERVICE (NBS).png" alt="icon not found" />
                                </div>
                                <div class="service-4__item-text">
                                    <h4 class="mb-15 mb-xs-10 title-animation"><a href="service-details.html">We provide need-based service (NBS). We do cooperation with your &amp; institutions according to your requirements.</a></h4>
                                    <a class="rr-a-btn" href="service-details.html">Read More <i class="fa-solid fa-circle-plus"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-6">
                            <div class="service-4__item mb-30">
                                <div class="service-4__item-icon mb-40 mb-xs-20">
                                    <img src="assets/imgs/about-us/EVALUATION BASED PRE-CONSULTATIONS.png" alt="icon not found" />
                                </div>
                                <div class="service-4__item-text">
                                    <h4 class="mb-15 mb-xs-10 title-animation"><a href="service-details.html">We do Evaluation based Pre-Consultations.</a></h4>
                                    <a class="rr-a-btn" href="service-details.html">Read More <i class="fa-solid fa-circle-plus"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-6">
                            <div class="service-4__item mb-30">
                                <div class="service-4__item-icon mb-40 mb-xs-20">
                                    <img src="assets/imgs/about-us/SECOND OPINION CONSULTATIONS.png" alt="icon not found" />
                                </div>
                                <div class="service-4__item-text">
                                    <h4 class="mb-15 mb-xs-10 title-animation"><a href="service-details.html">We provide Second Opinion Consultations according to your needs.</a></h4>
                                    <a class="rr-a-btn" href="service-details.html">Read More <i class="fa-solid fa-circle-plus"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-6">
                            <div class="service-4__item mb-30">
                                <div class="service-4__item-icon mb-40 mb-xs-20">
                                    <img src="assets/imgs/about-us/ELIMINATING LANGUAGE BARRIERS.png" alt="icon not found" />
                                </div>
                                <div class="service-4__item-text">
                                    <h4 class="mb-15 mb-xs-10 title-animation"><a href="service-details.html">We assist you in eliminating the language barriers.</a></h4>
                                    <a class="rr-a-btn" href="service-details.html">Read More <i class="fa-solid fa-circle-plus"></i></a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

       
    );

}